import axios from "axios";
import HttpService from "../http";

const PublicService = () => {
  const { httpRequest, httpDecryptRequest, httpChatBotResponse } = HttpService();

  const getBlogList = (search) =>
    new Promise((resolve, reject) => {
      axios({
        method: "GET",
        url: "https://holypills.in/blog/wp-json/wp/v2/posts?per_page=3",
        params: {
          ...search,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then(resolve)
        .catch(reject);
    });

  const healthPage = (search) =>
    new Promise((resolve, reject) => {
      httpRequest("GET", "user/v1/page/content", {}, search)
        .then(resolve)
        .catch(reject);
    });

  const getDoctorList = (search) =>
    new Promise((resolve, reject) => {
      httpRequest("GET", "user/v1/doctor", {}, search)
        .then(resolve)
        .catch(reject);
    });

  const getDoctorDetail = (search) =>
    new Promise((resolve, reject) => {
      httpRequest("GET", "user/v1/doctor/detail", {}, search)
        .then(resolve)
        .catch(reject);
    });

const getSpecializationList = (search) =>
    new Promise((resolve, reject) => {
      httpDecryptRequest("GET", "master/v1/specialization_list", {}, search)
        .then(resolve)
        .catch(reject);
    });
    

  const getOpenAiPrompt = (payload) =>
    new Promise((resolve, reject) => {
      httpChatBotResponse("POST", "user/v1/home/chat", payload, {})
        .then(resolve)
        .catch(reject);
    });

    const getFaqApi = (search="") =>
      new Promise((resolve, reject) => {
        httpRequest("GET", "user/v1/settings/faqs", {},search)
          .then(resolve)
          .catch(reject);
      });

  const getTermsApi = (search) =>
    new Promise((resolve, reject) => {
      httpChatBotResponse("GET", "master/v1/terms", {}, search)
        .then(resolve)
        .catch(reject);
    });

  const getPolicyApi = (search) =>
    new Promise((resolve, reject) => {
      httpChatBotResponse("GET", "master/v1/policy", {}, search)
        .then(resolve)
        .catch(reject);
    });


  const getCountriesApi = (search) =>
    new Promise((resolve, reject) => {
      httpDecryptRequest("GET", "master/v1/country_list", {}, search)
        .then(resolve)
        .catch(reject);
    });
  return { healthPage, getBlogList, getDoctorList, getDoctorDetail, getSpecializationList, getOpenAiPrompt, getTermsApi, getPolicyApi, getCountriesApi,getFaqApi };
};

export { PublicService };
